import axios from "axios"
import StorageUtil from '@/components/config/StorageUtil.js'

var Axios = axios.create();
Axios.defaults.baseURL="http://xiaozhaopin.cn:8080/xzyp/front/api";
// Axios.defaults.baseURL="http://127.0.0.1:8080/xzyp/front/api";


// 请求拦截
Axios.interceptors.request.use(
  (config) => {
    // token认证写在这里
    var user_token = StorageUtil.Local.get("user_token");
    // token这个请求头，使我们自定义的头
    config.headers.user_token = user_token;

    return config;
  },
  (err) => {
    Promise.reject(err);
  }
);

// 响应拦截
Axios.interceptors.response.use(
  (config) => {
    return config;
  },
  (err) => {
    Promise.reject(err);
  }
);
// get封装
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    Axios({
      url,
      params,
      method: "get",
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
// post封装
export function post(url, params = {}, data = {}) {
  return new Promise((resolve, reject) => {
    Axios({
      url,
      method: "post",
      params,
      data,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
// delete封装
export function del(url, params = {}, data = {}) {
  return new Promise((resolve, reject) => {
    Axios({
      url,
      method: "delete",
      params,
      data,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
//   Blob封装,resopnseType:Blob一般是用于文件下载
export function getBlob(url, params = {}) {
  return new Promise((resolve, reject) => {
    Axios({
      url,
      method: "get",
      params,
      responseType: 'blob'
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// 文件上传封装
export function uploadFile(url, formData, params = {}) {
  return new Promise((resolve, reject) => {
    Axios({
      url,
      method: "post",
      params,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// postJson封装 - 专门用于发送JSON格式数据
export function postJson(url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios({
      url,
      method: "post",
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
// postJson封装 - 专门用于发送JSON格式数据
export function delJson(url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios({
      url,
      method: "delete",
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export default {
  get,
  post,
  del,
  getBlob,
  uploadFile,
  postJson,
  delJson
}


// WEBPACK FOOTER //
// ./src/components/config/APIConfig.js